import React, { useState } from "react";
import { useSelector } from "react-redux";
import InformationsDeletedOverlay from "./deleted-infos/InformationsDeletedOverlay";
import { isSegFeatureEnabled, SegFlags } from "../../../../../../../common/providers";

export default function DeletedVersionLayer({ deletedData, metadata, height, priority, onSetPriority }) {
	const redressingInformation = useSelector(({ srDocument }) => srDocument.redressingInformation);
	const showVersioning = useSelector(({ srDocument }) => srDocument.showVersioning);
	const [hoveredWarning, setHoveredWarning] = useState(null);
	return (
		<>
			{isSegFeatureEnabled(SegFlags.VERSIONS) &&
				showVersioning &&
				!redressingInformation &&
				Array.isArray(deletedData) &&
				deletedData
					.filter((sentence) => sentence?.informationId && sentence.deletedInfosIds.length > 0)
					.map((x) => (
						<InformationsDeletedOverlay
							key={x.informationId}
							deletedData={x}
							height={height}
							hoveredWarning={hoveredWarning}
							metadata={metadata}
							priority={priority}
							setHoveredWarning={setHoveredWarning}
							onSetPriority={onSetPriority}
						/>
					))}
		</>
	);
}
